import { render, staticRenderFns } from "./EmployeeSetting.vue?vue&type=template&id=53c2df68"
import script from "./EmployeeSetting.vue?vue&type=script&lang=js"
export * from "./EmployeeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports